module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-virtual-thank-you"
  }, [_vm._m(0), _c('div', {
    staticClass: "pages-virtual-thank-you__socials"
  }, [_c('a', {
    staticClass: "pages-virtual-thank-you__facebook",
    attrs: {
      "href": "https://www.facebook.com/starsmilesorthopedo"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "fb"
    }
  })], 1), _c('a', {
    staticClass: "pages-virtual-thank-you__instagram",
    attrs: {
      "href": "https://www.instagram.com/starsmilesorthopedo/?ref=badge"
    }
  }, [_c('Icon', {
    attrs: {
      "name": "ig"
    }
  })], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pages-virtual-thank-you__thank-you"
  }, [_c('h1', [_vm._v("Thank you for submitting your request!")]), _c('div', {
    staticClass: "pages-virtual-thank-you__text"
  }, [_vm._v("Thank you for submitting a virtual consult request. Once you have taken your photos please send them to "), _c('a', {
    attrs: {
      "href": "mailto:info@starsmilesorthopedo.com"
    }
  }, [_vm._v("info@starsmilesorthopedo.com")]), _vm._v(". We will be contacting you soon to set up a time and date for your virtual exam.")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-964e6320","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/pages/virtual-thank-you/virtual-thank-you.pug
// module id = 719
// module chunks = 1